import script from "./_lottery-countdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./_lottery-countdown.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__